module.exports = __webpack_public_path__ + "img/1@2x.ae2b71ad.png";